import styles from '@/components/Organisms/DIT/DITTree/DITTree.module.scss'
import Tooltip from '@mui/material/Tooltip'
import React, { FC } from 'react'
import {
  ditSliceReducer,
  ditSliceSelectors,
} from '@/components/Organisms/DIT/store'
import { useAppSelector } from '@/hooks'
import PlayCircleIcon from '@mui/icons-material/PlayCircle'
import IconAddDoc from '@/components/Atoms/Icons/IconAddDoc'
import IconAddDoc2 from '@/components/Atoms/Icons/IconAddDoc2'

type Props = {
  name: string
  id: number
  programIcon: React.ReactNode
}
const DITProgramState: FC<Props> = ({ name, id, programIcon }) => {
  const status = useAppSelector(ditSliceSelectors.stateDitStatus)
  const isTarget = status?.id === id
  const hasError = isTarget && !status?.lastVersion
  return (
    <span
      className={styles.ProgramState}
      style={{ cursor: 'pointer' }}
    >
      {isTarget ? (
        <PlayCircleIcon
          htmlColor='rgba(0, 0, 0, 0.54)'
          fontSize='medium'
        />
      ) : (
        programIcon
      )}
      {name}
      {hasError && (
        <Tooltip
          title='Отредактированная программа не отправлена'
          placement='top'
        >
          <span className={styles.Asterisk}>*</span>
        </Tooltip>
      )}
    </span>
  )
}

export default DITProgramState
